<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>

<template>
  <UButton
    v-bind="$attrs"
    class="min-h-16 cursor-pointer justify-center rounded-full border-0 bg-[#1678e5] px-8 py-4 font-[Fredoka,Montserrat,sans-serif] text-lg font-semibold text-white shadow-[0_10px_0_#0d4891,0_16px_24px_rgba(13,72,145,0.22)] transition-[transform,box-shadow,background] duration-150 ease-in-out hover:-translate-y-0.5 hover:bg-[#2f8cf1] hover:shadow-[0_12px_0_#0d4891,0_18px_28px_rgba(13,72,145,0.24)] active:translate-y-[5px] active:shadow-[0_3px_0_#0d4891,0_6px_12px_rgba(13,72,145,0.2)]"
  >
    <slot />
  </UButton>
</template>
